import { isSupportedAssetType, safeGetAssetType } from 'personalization-lib/utils/assetTypes';
import { isSupportedSegmentType } from 'personalization-lib/utils/segments';
import { getSegment } from 'personalization-lib/utils/personalizationStrategy/segments';
export const isNewVariantForStrategy = panelData => {
  const data = panelData;
  return Boolean(data.strategyId);
};
export const getNewVariantForStrategyInitialData = panelData => ({
  strategyId: panelData.strategyId,
  assetType: panelData.assetType,
  assetId: panelData.assetId.toString(),
  assetName: panelData.assetName
});
export const getInitialDataForStrategy = (strategy, assetName) => {
  const assetCoordinates = strategy === null || strategy === void 0 ? void 0 : strategy.assetCoordinates;
  return assetName && assetCoordinates && isSupportedAssetType(assetCoordinates.source) ? {
    strategyId: strategy.id,
    assetType: assetCoordinates.source,
    assetId: assetCoordinates.id.toString(),
    assetName
  } : undefined;
};

/** App-facing util to create type-safe initial data for a new variant */
export const createVariantInitialData = (data = {}) => {
  const {
    assetType,
    assetId,
    assetName,
    targetingConfig,
    strategyId
  } = data;
  if (!assetType || !isSupportedAssetType(assetType)) {
    return targetingConfig ? {
      targetingConfig
    } : undefined;
  }
  if (targetingConfig) {
    return {
      targetingConfig,
      assetType
    };
  }
  if (assetId && assetName) {
    return strategyId ? {
      strategyId,
      assetType,
      assetId,
      assetName
    } : {
      assetType,
      assetId,
      assetName
    };
  }
  return {
    assetType
  };
};
export const isNewStrategyForSegment = panelData => {
  const data = panelData;
  return Boolean(data.targetingConfig && getSegment(data));
};
export const getNewStrategyForSegmentInitialData = panelData => {
  const segment = getSegment(panelData);
  return segment && isSupportedSegmentType(segment.segmentType) ? {
    segmentType: segment.segmentType,
    segmentId: segment.implementationObjectId,
    assetType: safeGetAssetType(panelData.assetType)
  } : undefined;
};
export const isNewStrategyForAssetType = panelData => {
  const data = panelData;
  return Boolean(data.assetType && !('targetingConfig' in data) && !('assetId' in data));
};
export const getNewStrategyForAssetTypeInitialData = panelData => ({
  assetType: safeGetAssetType(panelData.assetType)
});
export const isNewStrategyForUnpersonalizedAsset = panelData => {
  const data = panelData;
  return Boolean(data.assetType && data.assetId && data.assetName && !('strategyId' in data) && !('targetingConfig' in data));
};
export const getNewStrategyForUnpersonalizedAssetInitialData = panelData => ({
  assetType: safeGetAssetType(panelData.assetType),
  assetId: panelData.assetId.toString(),
  assetName: panelData.assetName
});